import { Backdrop } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Banner from "../components/Banner";
import Products from "../components/Products";
import { getParamUrl } from "../extra/utils";
import { useStyles } from "../styles/homeStyles";
import BHSucKhoe from "./BHSucKhoe";

import comingSoon from "../assets/icons/coming-soon.svg";
import iconX from "../assets/images/icon-x.png";
import popup from "../assets/images/popup-1.png";

function Home({ isMobile, dispatch, state }) {
  const { product } = useParams();
  const currentProducts = (product || "").split(".");
  const currentProduct = currentProducts[0];
  const token = currentProducts[1] || null;
  const router = useLocation();
  const platform = getParamUrl("platform");
  const partner = getParamUrl("partner_id");

  const [openPopup, setOpenPopup] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (isMobile) {
      const handleScroll = () => {
        const benefitElement = document.getElementById("benefit");
        if (benefitElement) {
          const elementPosition = benefitElement.getBoundingClientRect().top;
          if (elementPosition < 350) {
            dispatch({ type: "onChangeScroll", value: true });
          } else {
            dispatch({ type: "onChangeScroll", value: false });
          }
        }
      };

      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  useEffect(() => {
    //khuyen mai
    // const targetDate = new Date("12/08/2024"); //endDate
    // const currentDate = new Date();
    // if (currentDate > targetDate) {
    //   setOpenPopup(false);
    // } else {
    //   setOpenPopup(true);
    // }

    switch (currentProduct) {
      case "bao-hiem-suc-khoe":
        dispatch({ type: "selectedProduct", id: 8 });
        break;

      case "bao-hiem-dot-quy":
        dispatch({ type: "selectedProduct", id: 2 });
        break;

      case "bao-hiem-tai-nan":
        dispatch({ type: "selectedProduct", id: 5 });
        break;

      case "bao-hiem-benh-hiem-ngheo":
        dispatch({ type: "selectedProduct", id: 6 });
        break;

      case "bao-hiem-nha":
        dispatch({ type: "selectedProduct", id: 7 });
        break;

      case "bao-hiem-du-lich":
        dispatch({ type: "selectedProduct", id: 23 });
        break;

      case "bao-hiem-sinh-mang":
        dispatch({ type: "selectedProduct", id: 42 });
        break;

      case "bao-hiem-nhan-tho":
        dispatch({ type: "selectedProduct", id: 43 });
        break;

      case "bao-hiem-ung-thu":
        dispatch({ type: "selectedProduct", id: 44 });
        break;
      
      case "bao-hiem-phi-nhan-tho":
        dispatch({ type: "selectedProduct", id: 2 });
        break;

      default:
        break;
    }
  }, [state.products]);

  const renderProductPage = () => {
    // const currentProduct = getParamUrl("code");

    switch (currentProduct) {
      case "health":
      case "bao-hiem-suc-khoe":
        return (
          <BHSucKhoe
            isMobile={isMobile}
            productSelected={state.productSelected}
          />
        );
      
      default:
        if (router?.pathname?.includes('/bao-hiem-suc-khoe'))
        {
          return (
            <BHSucKhoe
              isMobile={isMobile}
              productSelected={state.productSelected}
            />
          );
        }
        return (
          <div style={{ textAlign: "center", margin: "15% 0" }}>
            <img src={comingSoon} alt="coming-soon" className="coming-logo" />
          </div>
        );
    }
  };

  return (
    <div className={classes.container}>
      {platform !== "app" && !partner && (
        <>
          <Banner isMobile={isMobile} banners={state.banners} />
          <Products
            isMobile={isMobile}
            state={state}
            dispatch={dispatch}
            token={token}
          />
        </>
      )}
      {renderProductPage()}
      {/* popup img */}
      {/* {openPopup && (
        <Backdrop className={classes.popUp} open={openPopup}>
          <div className="wrapper">
            <img
              src={iconX}
              alt="iconX"
              className="icon-close"
              onClick={() => setOpenPopup(false)}
            />
            <img src={popup} alt="popup" className="popup-img" />
          </div>
        </Backdrop>
      )} */}
    </div>
  );
}

export default Home;
